angular.module('SpidApp')

.factory('Conversion',
[function () {
	var Conversion = {
		fromRef: function (destCurrency, value) {
			if (!destCurrency || value === undefined || value === null) {
				throw 'Conversion::fromRef() - Missing parameters'
			}

			return + (value * destCurrency.rate).toFixed(2)
		},
		toRef: function (originCurrency, value) {
			if (!originCurrency || value === undefined || value === null) {
				throw 'Conversion::toRef() - Missing parameters'
			}

			return + (value / originCurrency.rate).toFixed(2)
		}
	};

	return Conversion;
}]);